import { css } from 'styled-components';
import { colors } from '../../style';

export const variants = {
  transparent: {
    backgroundColor: 'transparent',
  },
  gray100: css`
    background-color: ${colors.gray100};
  `,
  'dark-opacity': css`
    &:after {
      content: ' ';
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      opacity: 0.6;
      background-color: black;
    }
  `,

  'action-light': css`
    background: ${props => props.theme.actionLight};
  `,
};
